import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';

import { Container } from './styles';

interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'children'> {
    placeholder?: string;
    value: string | any;
    name?: string;
    type?: 'text' | 'password' | 'email' | 'tel' | 'number';
    mask?: string;
    onChangeText: (value: string | any) => void;
    search?: boolean;
    className?: any;
    title?: string;
    disabled?: boolean;
    error?: string;
    obrigatorio?: boolean;
}

const InputDefault = ({
    placeholder,
    value,
    name,
    mask = '',
    onChangeText,
    type,
    search = false,
    title = '',
    className = '',
    disabled = false,
    error = '',
    obrigatorio = false,
    ...rest
}: InputProps) => {
    const [valueInput, setValueInput] = useState<string>(value);

    useEffect(() => {
        setValueInput(value);
    }, [value]);

    function handleOnChange(e: React.FormEvent<HTMLInputElement>) {
        setValueInput(e.currentTarget.value);
        onChangeText(e.currentTarget.value);
    }

    return (
        <Container className={`default-input ${className}`}>
            {/* {search && <IconSearch />} */}
            {title && <p className="title">
                {title}
                {(obrigatorio || error) && <span>*</span>}
            </p>}
            <InputMask
                type={type}
                value={valueInput}
                name={name}
                onChange={handleOnChange}
                placeholder={placeholder}
                disabled={disabled}
                mask={mask}
                {...rest}
            />
            <span>{error && error !== '*' ? error : ''}</span>
        </Container>
    );
};

export default InputDefault;